<template>
  <div>

    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="用户名">
        <el-input size="small" v-model="formInline.userName" placeholder="输入用户名"></el-input>
      </el-form-item>
      <!-- <el-form-item label="币种">
        <el-select size="small" v-model="formInline.tokenName" placeholder="请选择">
          <el-option v-for="item in typeToken" :label="item.key" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="时间">
        <el-date-picker
        size="small"
        v-model="timeVal"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      </el-form-item>
      
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">

      <el-table-column align="center"  prop="userName" label="用户名" min-width="120">
      </el-table-column>
      <el-table-column align="center"  prop="amountM" label="下数量 (M)" min-width="100">
      </el-table-column>
      <!-- <el-table-column align="center" label="状态" min-width="100">
          <template slot-scope="scope">
            
            <div v-if="scope.row.status == 'start'">开始</div>
            <div v-if="scope.row.status == 'finish'">完成</div>
            <div v-if="scope.row.status == 'waiting'">等待</div>
          </template>
        </el-table-column> -->
      <el-table-column align="center"  prop="amountL" label="下数量 (L)" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="winM" label="赢 M" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="winL" label="赢 L" min-width="100">
      </el-table-column>
      <el-table-column align="center"  prop="playId" label="playId" min-width="100">
      </el-table-column>
      <el-table-column align="center" prop="setupTime" label="创建时间" min-width="200">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import { DxOrders } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
     
      formInline: {
        "from": 1,
        "limit": 10,
        "startTime": "",
        "endTime": "",
        "userName": "",
        "playId": ""
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      typeToken: [
        { key: '请选择', value: '' },
        { key: 'USDT', value: 'USDT' },
        { key: 'MCoin', value: 'MCoin' },
      ],
      timeVal:"",
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取转入列表
    getdata(parameter) {
      this.loading = true
      DxOrders(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.list
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.from
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },

    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageSize = parm.pageSize
      this.formInline.from = (parm.currentPage-1)*(this.pageparm.pageSize) + 1
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },

    // 搜索事件
    search() {
      this.pageparm.currentPage = 1
      this.formInline.from = 1
      console.log(this.timeVal)
      if(this.timeVal instanceof Array){
        this.formInline.startTime = this.timeVal[0]+' 00:00:00'
        this.formInline.endTime = this.timeVal[1]+' 23:59:59'
      }else{
        this.formInline.startTime = ''
        this.formInline.endTime = ''
      }
      this.getdata(this.formInline)
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.box-card{
  width: 600px;
  margin-top: 20px;
  font-size: 14px;
}
.box-card div{
  display: flex;
}
.box-card div p{margin-right: 10px;}
.box-card p{margin: 0;margin-bottom: 10px;}
.box-card h3{margin: 0;margin-bottom: 15px;}
</style>

 
 


// WEBPACK FOOTER //
// src/views/wallet/SizeView.vue